import { useQuery } from '@tanstack/react-query';

import { toContract } from '@/hooks/api/use-contracts';
import { getData } from '@/lib/api/client-v2';
import { queryKeys } from '@/lib/query-keys';
import type { ContractV2 } from '@/types/api/contract';
import { ENDPOINTS } from '@/types/api/endpoints';

/**
 * Contrats en attente de pièces justificatives (bloc « À faire » de l'accueil).
 *
 * Ancien `state.waiting_doc_contracts.data` : relu à chaque montage du bloc, sans popin d'erreur.
 */
export const useWaitingDocContracts = () =>
    useQuery({
        queryKey: queryKeys.waitingDocContracts,
        queryFn: () =>
            getData<ContractV2[]>(ENDPOINTS.contracts, { waiting_document: 1 }).then((contracts) =>
                contracts.map(toContract),
            ),
        refetchOnMount: 'always',
    });
